/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import Form from '../Forms/Forms';
import './RoiCalculator.scss';
import Results from '../Results/Results';
import { RoiCalculatortProps } from '../../lib/type';

// Defining a type for selectedOption context element

interface outputInterface {
  reduceOperationalCostLow: number;
  reduceOperationalCostHigh: number;
  reduceHandleTimesLow: number;
  reduceHandleTimesHigh: number;
  increaseProductivityLow: number;
  increaseProductivityHigh: number;
  totalAnnualSavingsLow: number;
  totalAnnualSavingsHigh: number;
}

export const layoutContext = createContext({
  output: {
    reduceOperationalCostLow: 0,
    reduceOperationalCostHigh: 0,
    reduceHandleTimesLow: 0,
    reduceHandleTimesHigh: 0,
    increaseProductivityLow: 0,
    increaseProductivityHigh: 0,
    totalAnnualSavingsLow: 0,
    totalAnnualSavingsHigh: 0,
  },
  setOutput: (output: outputInterface) => {},
});

const RoiCalculator = ({
  configuration,
  jsondata,
}: RoiCalculatortProps): ReactElement => {
  const [output, setOutput] = useState({
    reduceOperationalCostLow: 0,
    reduceOperationalCostHigh: 0,
    reduceHandleTimesLow: 0,
    reduceHandleTimesHigh: 0,
    increaseProductivityLow: 0,
    increaseProductivityHigh: 0,
    totalAnnualSavingsLow: 0,
    totalAnnualSavingsHigh: 0,
  });

  return (
    <layoutContext.Provider value={{ output, setOutput }}>
      <div className="roi-calculator widget-styles">
        <Form contents={configuration.forms} jsondata={jsondata} />
        <Results contents={configuration.results} />
      </div>
    </layoutContext.Provider>
  );
};

export default RoiCalculator;
